/*
 * Helper methods
 * @author: Elton Jain
*/

define('Helper',[
    'jquery','Config'
], function ($, Config) {
    "use strict";

    return {
        showLoader: function (show) {
            if(show === false) {
                // hide
            } else {
                // show
            }
        },
        redirectLogin: function () {
            window.location.href = "/login?redirect_url=" + window.location.href;
        },

        // Open new window
        newWindow: function (url, width, height) {
            if(url) {
                if(this.isSafariBrowser()) {
                    window.open(url);
                } else {
                    window.open(url, "popupWindow", "width=600,height=600,scrollbars=yes");    
                }
            }
        },

        nl2br: function (str) {
            return str.replace(new RegExp('\r?\n','g'), '<br />');
        },

        // All URL Things
        Url: {
            getParam: function (name) {
                name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                    results = regex.exec(location.search);
                return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
            },
            hasParam: function (name) {
                return this.getParam(name) !== null && this.getParam(name).trim() !== "" ? true : false;
            },
            add: function (params) {
                // Add/update params to URL

            }
        },

        // GeoLocation
        getGeoLocation: function (successCallback, errCallback, options) {
            if(navigator.geolocation && successCallback) {
                navigator.geolocation.getCurrentPosition(successCallback, errCallback, options);
            }
        },

        // Highlight matching text
        highlight: function(src, term) {
            var pattern, words,
            highlightCallback = function(p1, p2) {
                return ((p2 === undefined) || p2 == '') ? p1 : '<strong>' + p1 + '</strong>';
            };
            term = term.replace(/[^\w\s]/g, ''); // Remove any special characters
            term = term.replace(/\s\s+/g, ' ').trim(); // Remove extra spaces if any
            words = term.split(' ');

            for(var i = 0;i < words.length;i++) {
                if(words[i] && words[i].length <= 2) {
                    continue;
                }
                pattern = new RegExp('<[^>]+>|(' + words[i] + ')', "gi");
                src = src.replace(pattern, highlightCallback); // Add bold tags around matched text
            }

            return src;
        },

        debounce: function(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        },

        // Check if date is valid
        isValidDate: function (date) {
            if ( Object.prototype.toString.call(date) !== "[object Date]" ) {
                return false;
            }
            return !isNaN(date.getTime());
        },

        timeAgo: function (time) {
            switch (typeof time) {
                case 'number': break;
                case 'string': time = +new Date(time); break;
                case 'object': if (time.constructor === Date) time = time.getTime(); break;
                default: time = +new Date();
            }
            var time_formats = [
                [60, 'seconds', 1], // 60
                [120, '1 minute ago', '1 minute from now'], // 60*2
                [3600, 'minutes', 60], // 60*60, 60
                [7200, '1 hour ago', '1 hour from now'], // 60*60*2
                [86400, 'hours', 3600], // 60*60*24, 60*60
                [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
                [604800, 'days', 86400], // 60*60*24*7, 60*60*24
                [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
                [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
                [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
                [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
                [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
                [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
                [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
                [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
            ];
            var seconds = (+new Date() - time) / 1000,
                token = 'ago', list_choice = 1;

            if (seconds == 0) {
                return 'Just now';
            }
            if (seconds < 0) {
                seconds = Math.abs(seconds);
                token = 'from now';
                list_choice = 2;
            }
            var i = 0, format;
            while (format == time_formats[i++])
                if (seconds < format[0]) {
                    if (typeof format[2] == 'string')
                        return format[list_choice];
                    else
                        return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
                }
            return time;
        },
        getUserAgent: function () {
            return navigator.userAgent.toLowerCase();
        },
        
        isSafariBrowser: function () {
            this.setDevice();
            var ua = this.getUserAgent();
            return (ua.indexOf('safari') != -1 && ua.indexOf('Chrome') == -1);
        },

        /**
         * Check if device is mobile or desktop and set appropriately
         */
        setDevice: function() {
            var check = false; // check if device is mobile/desktop
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
            if(check) {
                window._gtap.settings.device = 'mobile';
            } else {
                window._gtap.settings.device = 'desktop';
            }
        },

        /**
         * Add text to clipboard when copying text on site
         */
        addLinkOnCopy: function (event) {

            var emptyClipboard = function() {
                if (window.getSelection) {
                    if (window.getSelection().empty) {  // Chrome
                        window.getSelection().empty();
                    } else if (window.getSelection().removeAllRanges) {  // Firefox
                        window.getSelection().removeAllRanges();
                    }
                } else if (document.selection) {  // IE?
                    document.selection.empty();
                }
            };
            
            //Get the selected text and append the extra info
            try {
                var body_element = document.getElementsByTagName('body')[0],
                selection,
                pagelink = '';

                var type = Config.get('copy_type');

                if($(event.target).parents('li').data('action') === 'copy') {
                    emptyClipboard();
                    pagelink = $(event.target).parents('li').data('url');
                } else if(type === 'invite') {
                    emptyClipboard();
                    pagelink = $('#inviteURL').val();
                    Config.set('copy_type','');
                }

                selection = window.getSelection();
                
                var copytext = selection + pagelink;
                var newdiv = document.createElement('div');
                newdiv.style.position='absolute';
                newdiv.style.left='-99999px';
                body_element.appendChild(newdiv);
                newdiv.innerHTML = copytext;
                selection.selectAllChildren(newdiv);
                require(['Toastr'], function(Toastr) {
                    new Toastr({
                        'message': Config.get('lang.succ_copy')
                    });
                });
                window.setTimeout(function() {
                    body_element.removeChild(newdiv);
                },0);
            } catch (e) {

            }
        },

        /**
         * Lazy load Images for Feed Question
         */
        loadFeedImages: function ($htmlToUpdate) {
            $htmlToUpdate.find('figure.q-image').each(function () {
                var $ele = $(this),
                    imageSrc = $ele.data('image');
                $ele.find('img').attr('src', imageSrc);
            });
        },

        /**
         * Linkify feed content with reqd options
         */
        linkifyFeedContent: function ($container) {
            if($container) {
                require(['linkify'], function (linkify) {
                    $container.linkify({
                        linkAttributes: {
                            rel: 'nofollow'
                        },
                        validate: function (value, type) {
                            return type !== 'url' || /^(http|www)s?/.test(value);
                        }
                    });
                });
            }
        },

        /**
         * General Message Dialog/Popup
         * @options []
         *  image: null,
            centered: true,
            imageIsHeaderBG: false,
            heading: null,
            description: null,
            buttonText: 'Done'
         */
        showDialog: function (options) {
            // Instantiable
            require(['UI', 'JSTemplate', 'History'], function (UI, template, History) {
                options = options || {};
                window.____dlgc = window.____dlgc || 0;
                options.id = "popMsgDlg-"+(++window.____dlgc);

                var tplDialog = template('tplMessageDialog', options);
                UI.noscroll();
                $(tplDialog).appendTo(UI.$b).addClass('open');
                History.pushState({
                    url: window.location.href,
                    popupId: options.id,
                    removeEl: true,
                    callback: function () {
                        window.____dlgc--;
                        if(options.onClose) {
                            options.onClose();
                        }
                    }
                });
            });
        },
        /**
         * [showInvitePopup Show Share / Invite friends popup]
         * @param  {[type]} options [description]
         * @return {[type]}         [description]
         */
        showInvitePopup: function (options) {
            var url = (window._gtap.data.userData) ? '?pt_invite_code=' + window._gtap.data.userData.slug : '';
            require(['UI', 'JSTemplate', 'History'], function (UI, template, History) {
                options = options || {};
                options = $.extend({
                    url: window.location.origin + url
                }, options);

                var html = template('tplInviteFriends', options);

                UI.$b.append(html);
                History.pushState({
                    popupId: 'popup-invite-menu'
                });
            });
            return false;
        },

        getVideoUrl: function (options) {
            if(!options.videoId) {
                return null;
            }
            var url = "https://www.youtube.com/embed/" + options.videoId;
            
            url += "?showinfo=0&rel=0&modestbranding=1&playsinline=1&iv_load_policy=3";

            if(options.autoplay === true) {
                url += "&autoplay=1";
            }

            if(options.controls === true) {
                url += "&controls=1";
            } else {
                url += "&controls=0";
            }

            return url;
        },

        showFeedbackPage: function (e) {
            require(['UI', 'History'], function (UI, History) {
                History.pushState({
                    popupId: 'feedbackContainer',
                    isPage: true,
                    removeEl: false,
                    url: '/feedback',
                    callback: function () {
                        UI.showBackButton(false);
                    }
                });
                if(e) {
                    e.preventDefault();
                }
                var $elFeedbackContainerId = $('#feedbackContainer');

                if ($elFeedbackContainerId.length > 0) {
                    UI.showBackButton();
                    UI.noscroll();
                    $elFeedbackContainerId.fadeIn('500ms');
                } else {
                    $.post('ajax/feedback', function(results) {
                        if (results.status === true) {
                            UI.showBackButton();
                            UI.$b.append(results.response.form);
                            UI.noscroll();
                        }
                    });
                }
                if(UI.$header.is('.open')) {
                    UI.$header.removeClass('open');
                    $('#btnNavPageMenu').removeClass('active');
                }
            });
        },

        /**
         * [getHashTags finds hashtags in a string and returns them in form of an array]
         * Author: Chiran Doshi
         */
        getHashTags: function(str) {
            var regex = /#([a-zA-Z0-9\u0E00-\u0E7F_]+)/g,
                matches = [],
                match = regex.exec(str);

            while (match != null) {
                if(matches.indexOf(match[0]) === -1) {
                    matches.push(match[0], match[1]);
                }
                match = regex.exec(str);
            }

            return matches;
        },

        parseTags: function(str) {
            var matches = this.getHashTags(str);

            for(var i = 0;i < matches.length/2;i++) {
                str = str.replace(matches[i*2],'<a class="booth-tag" href="/hashtag/' + matches[i*2+1] + '">' + matches[i*2] + '</a>');
            }

            return str;
        }
    };
});
